import React from "react";
import { ShieldCheck, Target, HeartHandshake, Award } from "lucide-react";

const Container = ({ children, className = "" }) => <div className={`max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 ${className}`}>{children}</div>;
const VALUES = [
  { icon: ShieldCheck, t: "Discrétion", d: "La confidentialité est au cœur de notre métier." },
  { icon: Target, t: "Efficacité", d: "Des process rigoureux au service de votre cabinet." },
  { icon: HeartHandshake, t: "Service humain", d: "Une relation de proximité et de confiance." },
  { icon: Award, t: "Qualité suisse", d: "L'exigence et la fiabilité en toutes circonstances." },
];

export default function About() {
  return (
    <div className="py-16 md:py-20">
      <Container>
        <span className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">À propos</span>
        <h1 className="mt-3 font-heading font-bold tracking-tight text-slate-900 text-4xl sm:text-5xl">Delya, votre partenaire administratif</h1>
        <p className="mt-6 text-lg text-slate-600 leading-relaxed">Delya est une société suisse spécialisée dans le secrétariat médical et l'assistance administrative à distance. Fondée par deux professionnelles de la gestion de cabinet, elle accompagne les médecins et les cabinets dans leur quotidien administratif, ponctuellement ou sur le long terme.</p>
        <p className="mt-4 text-lg text-slate-600 leading-relaxed">Notre mission : permettre aux praticiens de se concentrer sur l'essentiel — leurs patients — en leur offrant un secrétariat flexible, fiable et discret.</p>
        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-6">
          {VALUES.map((v, i) => (
            <div key={i} className="bg-white rounded-xl border border-slate-200 p-6 flex gap-4">
              <div className="h-11 w-11 rounded-lg bg-primary/10 flex items-center justify-center shrink-0"><v.icon className="h-5 w-5 text-primary" /></div>
              <div><h3 className="font-heading font-semibold text-slate-900">{v.t}</h3><p className="mt-1 text-sm text-slate-500 leading-relaxed">{v.d}</p></div>
            </div>
          ))}
        </div>
      </Container>
    </div>
  );
}
